/** Prefixo do texto da data de atualização, ao lado do título (protótipo). */
export const LAST_UPDATE_PREFIX = "Última Atualização";

export const DETAIL_SECTION_LOADING_MESSAGE = "Carregando…";

/** Vazio de uma seção que não informa o próprio texto (padrão global de estado vazio do Hub). */
export const DETAIL_SECTION_EMPTY_CONTENT = {
  title: "Nenhuma informação disponível",
  description: "Assim que houver dados para esta embarcação, eles aparecerão nesta seção.",
};
